export const actionTypes = {
  GET_KEY_POS: "GET_KEY_POS",
  SET_KEY_POS: "SET_KEY_POS",
  GET_KEY_POS_BY_ID: "GET_KEY_POS_BY_ID",
  SET_KEY_POS_BY_ID: "SET_KEY_POS_BY_ID",
  CREATE_CHILD_POS: "CREATE_CHILD_POS",
  GET_FILTERED_KEYPOS: "GET_FILTERED_KEYPOS",
  UPDATE_KEY_POS: "UPDATE_KEY_POS",
  EDIT_KEYPOS_FORM_CHANGE: "EDIT_KEYPOS_FORM_CHANGE",
  GET_DYNAMIC_FIELD_CONTROL: "GET_DYNAMIC_FIELD_CONTROL",
  SET_DYNAMIC_FIELD_CONTROL: "SET_DYNAMIC_FIELD_CONTROL"
};

export const actions = {
  getKeyPos: (payload) => ({
    type: actionTypes.GET_KEY_POS,
    payload: payload,
  }),

  setKeyPos: (payload) => ({
    type: actionTypes.SET_KEY_POS,
    payload: payload,
  }),

  getKeyPosById: (payload) => ({
    type: actionTypes.GET_KEY_POS_BY_ID,
    payload: payload,
  }),

  setKeyPosById: (payload) => ({
    type: actionTypes.SET_KEY_POS_BY_ID,
    payload: payload,
  }),

  setKeyPosEditForm: (payload) => ({
    type: actionTypes.EDIT_KEYPOS_FORM_CHANGE,
    payload: payload,
  }),

  createChildPos: (payload) => ({
    type: actionTypes.CREATE_CHILD_POS,
    payload: payload,
  }),

  updateKeyPos: (payload) => ({
    type: actionTypes.UPDATE_KEY_POS,
    payload: payload,
  }),

  getFilteredKeyPos: (payload) => ({
    type: actionTypes.GET_FILTERED_KEYPOS,
    payload: payload,
  }),

  getDynamicFieldControls: (payload) => ({
    type: actionTypes.GET_DYNAMIC_FIELD_CONTROL,
    payload: payload,
  }),

  setDynamicFieldControls: (payload) => ({
    type: actionTypes.SET_DYNAMIC_FIELD_CONTROL,
    payload: payload,
  }),
};
